import React from "react";
import PasswordRecovery from "../components/account/PasswordRecovery/PasswordRecovery";

const PasswordRecoveryPage = () => {
  return <PasswordRecovery />;
};

export default PasswordRecoveryPage;
